import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { DataGrid } from "components/DataGrid/DataGrid";
import { DynamicComponentHOC } from "components/DynamicComponentHOC/DynamicComponentHOC";
import { GroupPerson } from "components/GroupPerson/GroupPerson";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ModalStepper } from "components/ModalStepper/ModalStepper";
import { Notes } from "components/Notes/Notes";
import { TabBar } from "components/Tabbar/Tabbar";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AssignTypes, CartableType, MessageType } from "types/enum";
import { DynamicForm } from "types/types";
import { GUID_EMPTY } from "utils/constants";
import { DYNAMICFORMS } from "utils/dynamicForms";
import { ENDPOINTS } from "utils/endpoints";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { CancelAcceptReference, CancelFinishedReference, DeleteReference, FinishedReference, ReferReverse, RejectReference, UnderFollowup, acceptReference, getCartable, getJobReferrer, getJobRequester, getStartForm, ongoingReference, undoReference } from "./api/api";
import { AcceptSelfService } from "./components/AcceptSelfService/AcceptSelfService";
import { ActionList } from "./components/ActionList/ActionList";
import { getDynamicForm } from "./components/ActionList/api/api";
import { Actions } from "./components/ActionList/components/Actions/Actions";
import { Attachment } from "./components/ActionList/components/Attachment/Attachment";
import { ReferenceTree } from "./components/ActionList/components/ReferencesTree/ReferencesTree";
import { ReferencesActions } from "./components/ActionList/components/RefrenceAndActionsForm/RefrenceAndActions";
import { ArchiveForm } from "./components/ArchiveForm/ArchiveForm";
import { getArchivedJob } from "./components/ArchiveForm/api";
import { JobSendForm } from "./components/JobSendForm/JobSendForm";
import { JobStatus } from "./components/JobStatus/JobStatus";
import { ReferenceStepper } from "./components/ReferenceStepper/ReferenceStepper";
import { TerminatedForm } from "./components/Terminated/Terminated";
import { Toolbar } from "./components/Toolbar/Toolbar";
import { MoveTemp } from "./components/ActionList/components/Attachment/api/api";



interface propsCartablePage {
    type?: any; // => type is CartableType
}
export const CartablePage = ({ type }: propsCartablePage) => {
    let keys, cartable = [];
    let Total_records, pages;
    let [dynamicForm, setDynamicForm] = useState<DynamicForm | any>("GeneralRequestForm");
    let [showDynamicForm, setShowDynamicForm] = useState<boolean>(false);
    const [showDynamicFormView, setShowDynamicFormView] = useState<boolean>   (false);
    const [response, setResponse] = useState<Response | any>(null);
    const [referenceId, setReferenceId] = useState<string | any>(null);
    const [rowObject, setRowObject] = useState<string | any>(null);
    const referenceIdRef = useRef(referenceId);
    const [selectedStartingProcessId, setSelectedStartingProcessId] = useState<string | any>(null);
    const [selectedProcessFilterId, setSelectedProcessFilterId] = useState<string | any>(null);
    const [showActionForm, setShowActionForm] = useState<boolean>(false);
    const [showTerminatedForm, setShowTerminatedForm] = useState<boolean>(false);
    const [showReminder, setShowReminder] = useState(false);
    const [reload, setReload] = useState(false); // integer state
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [mode, setMode] = useState<string>();
    const [showReference, setShowReference] = useState(false);
    const [currentModalWidth, setCurrentModalWidth] = useState(70);
    const [showAttachment, setShowAttachment] = useState(false);
    const [ShowReferDescriptionForm, setShowReferDescriptionForm] = useState(false);
    const [ShowReferenceAndActions, setShowReferenceAndActions] = useState(false);
    const [ShowReferenceTree, setShowReferenceTree] = useState(false);
    const [loading, setLoading] = useState(false);
    const [ShowDynamicFormViewLoading, setShowDynamicFormViewLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [endpoint, setEndpoint] = useState<any>();
    const [createdRefrenceIdForm,setCreatedRefrenceIdForm]=useState<any>(null)
    const [showArchiveForm, setShowArchiveForm] = useState<any>(0);
    const [showJobSendForm, setShowJobSendForm] = useState<any>(false);
    const [typeOfDataGrid, setTypeOfDataGrid] = useState<any>(type);
    const layoutContext = useContext(LayoutContext);
    const [search, setsearch] = useState(null);
    const [showActions, setShowActions] = useState(false);
    const [modalFormLabel,setModalFormLabel]=useState<any>('')
    const[showAttachmentByDynamicForm,setShowAttachmentByDynamicForm]=useState<any>(false);
    const [filterAndSort, setFilterAndSort] = useState<any>(null);
    const [showstep, setShowstep] = useState<any>({});
    const [showAccept, setShowAccept] = useState<any>(true);
    const [Updated, setUpdated] = useState<any>(true);
    const [archivedList, setArchivedList] = useState<any>()
    const [curentTab, setCurentTab] = useState<any>("request")
    const [curentTabWithAttachment, setCurentTabWithAttachment] = useState<any>("request")
    const [buttonPrintObj, setButtonPrintObj] = useState<any>()
    const [acceptResult,setAcceptResult]=useState(false)
const [showNotes,setShowNotes]=useState(false)
const [OriginalOwnerId,setOriginalOwnerId]=useState<any>(null)
const [temporaryOwnerId,setTemporaryOwnerId]=useState<any>(null)


    let customFuction: any = [
        
        
    ]
    const navigate = useNavigate();


    if(type ==CartableType.Current ||type === CartableType.Ongoing ) {
        customFuction.push([(e) => { setReferenceId(e.Id); setMode("view"); processViewCallback(e?.Id);}, "eye", "view"])
        customFuction.push([(e) => { setReferenceId(e.Id);setMode("edit"); setShowReference(true);}, "share-from-square", "Reference"])
        customFuction.push([(e) => { setReferenceId(e.Id);setMode("edit"); setShowActionForm(true);}, "bolt", "action"])
        customFuction.push([(e) => { chatWithRequester(e.JobId) }, "paper-plane", "ChatWithRequester"])
        customFuction.push([(e) => { chatWithReferrer(e.Id) }, "paper-plane", "ChatWithReferrer"])
        customFuction.push([(e) => { setReferenceId(e.Id); setShowActions(true) }, "bolt", trans("submit")+" "+trans("report") ])
        customFuction.push([(e) => { setReferenceId(e.Id);setShowTerminatedForm(true)}, "flag-checkered", "finish"])
        customFuction.push([(e) => { setShowReferDescriptionForm(true) }, "reply", "reverse"])
    if(type !== CartableType.Ongoing) customFuction.push([(e) => { ongoingReferenceAsync(e.Id, true) }, "hourglass-half", "MoveToOngoing"])
        customFuction.push([(e) => { acceptReferenceAsync(e.Id, true) }, "check-circle", "accept","AssignType" ,AssignTypes.SELF_SERVICE])
        
    if(type === CartableType.Ongoing){
    customFuction.push([(e) => {
            if (referenceId){type === CartableType.Ongoing && ongoingReferenceAsync(referenceId, false)}else Toast(trans("Msg_SelectRow"), MessageType.warning)}, "arrow-rotate-left", "MoveToCurrentCartable"]
    )
    }
    }else if (type == CartableType.Referred){
        customFuction.push([(e) => { undoReferenceAsync(e.Id) }, "undo", "Undo"])
        customFuction.push([(e) => { UnderFollowupAsync(e.Id, true) }, "hourglass-half", "UnderFollowup"])
    }
    if( type !== CartableType.Draft){
        customFuction.push([(e) => { setReferenceId(e.Id); setShowReferenceAndActions(true) }, "clipboard", "referenceandactionshistory"])
        customFuction.push([(e) => { setReferenceId(e.Id); setShowReferenceTree(true) }, "clipboard", "referencestree"])
    }
    
    const tabChangeHandle = (tab) => {
        setCurentTab(tab)
    } 
      const tabChangeHandleWithAttachment = (tab) => {
        setCurentTabWithAttachment(tab)
    } 

    const Searchhandleer = (str) => {
        setPageNum(1);
        referenceIdRef.current = null
        setReferenceId(null);
        setRowObject(null);
        if (str === "") {
            setsearch(null)
            getCartableAsync(1, null )
    
        } else {
            setsearch(str)
            getCartableAsync(1 ,str)
        }
    }

    const handleAttachmentRow = (id) => {
        setEndpoint(ENDPOINTS.cartable.reference.attachments)
        setReferenceId(id)
        setShowAttachment(true)
    }
    const handlechangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("cartable" + type + `${selectedProcessFilterId}`, e.currentTarget.value)
        getCartableAsync(1)
    };

    const handleGoPage = (value) => {
        if (value) {
            if (value < 1 || value > pages) { }
            else { setPageNum(value); getCartableAsync(value); }
        } else {

        }
    };

    const HandleNextPage = () => {
        if (pageNum < pages) {
            setPageNum(+pageNum + 1);
            getCartableAsync(+pageNum + 1);
        }
    };
    const HandlePrevPage = () => {
        if (pageNum > 1) {
            setPageNum((pageNum) => { return +pageNum - 1 });
            getCartableAsync(+pageNum - 1);
        }
    };
    /* pagination area */



    const showDynamicFormViewCallback = (ans: boolean) => {
        setShowDynamicFormView(ans);
    }
    async function getStartFormAsync(id: string) {
        const lang = localStorage.getItem("DefaultLanguage");

        document.body.classList.add("loading-indicator-"+lang);
        try {
            setMode("create");
            const res = await getStartForm(id, layoutContext.currentUserPosition.PositionId);
            if (res.Data)
                setDynamicForm(res.Data);
            else
                setDynamicForm(undefined);
            if (dynamicForm) {
                setShowDynamicForm(true);
            }
            else { setShowDynamicForm(false) }

        } catch (error) {
            setDynamicForm(undefined);
            setShowDynamicForm(false)

        }
        document.body.classList.remove("loading-indicator-"+lang);
    }
/*     async function getFormViewAsync(id: string) {
       
        
        setShowDynamicFormViewLoading(false)
        try {
   
            const res = await getViewForm(id, layoutContext.currentUserPosition.PositionId);
            if (res.Data)
                setDynamicForm(res.Data);
            else
                setDynamicForm(undefined);
            if (dynamicForm) {
                setShowDynamicFormView(true);
                setShowNotes(true)
            }
            else { setShowDynamicFormView(false) }

        } catch (error) {
            setDynamicForm(undefined);
            setShowDynamicFormView(false)

        }
        setShowDynamicFormViewLoading(true)

    } */
        async function getFormViewAsync(id: string) {
            setShowDynamicFormViewLoading(false)
            try {
            const res = await getDynamicForm(id);
            if (res.Data){
    
                let data :any= []
                res.Data.map((item, index)=>{
                    if(item.Name != "SignatureForm"){
                        if(res.Data?.[index+1] &&  res.Data?.[index+1]?.Name =="SignatureForm" ){
                            data.push({...item , 
                                forms :[res.Data[index+1]]
                            })
                        }else{
                            data.push(item)
                        }
                    }
        
                })
                setDynamicForm(data);
            } else
                setDynamicForm(undefined);
            if (dynamicForm) {
                setShowDynamicFormView(true);
            }
            else { setShowDynamicFormView(false) }            
            } catch (error) {
                setMessageType("error")
            }
            setShowDynamicFormViewLoading(true)
        }
    async function chatWithRequester(e) {
            try {
                const res = await getJobRequester(e);
                if(res?.Data.Id && res?.Data.Id != GUID_EMPTY){

                    let item = {
                        Id:res?.Data.Id ,
                        name: res?.Data.Description
                    }
                    localStorage.setItem("JobRequester",JSON.stringify(item) );
                    window.open(`#/message`)
                }
            } catch (error) {

            }
            setShowReferDescriptionForm(false)
    }
    async function chatWithReferrer(e) {
            try {
                const res = await getJobReferrer(e);
                if(res?.Data.Id && res?.Data.Id != GUID_EMPTY){
                let item = {
                    Id:res?.Data.Id ,
                    name: res?.Data.Description
                }
                localStorage.setItem("JobRequester",JSON.stringify(item) );
                window.open(`#/message`)
              }
            } catch (error) {

            }
            setShowReferDescriptionForm(false)
    }
    async function ReferreverseAsync(e) {
        e.preventDefault()
        let ReverseDescription = e.target.ReverseDescription.value
        if (ReverseDescription.length > 0) {
            try {
                await ReferReverse(referenceId, ReverseDescription , e?.target?.sendMessageToPerformer.checked);
              //setReload(true)
              setShowReferDescriptionForm(false)
              getCartableAsync()
            } catch (error) {
            }
        }
    }

    async function ongoingReferenceAsync(referenceId, status) {
        try {
            await ongoingReference(referenceId, status);
        } catch (error) {

        }
        getCartableAsync()

    }
    async function UnderFollowupAsync(referenceId, status) {
        try {
            await UnderFollowup(referenceId, status);
        } catch (error) {

        }
        getCartableAsync()

    }
    async function acceptReferenceAsync(referenceId ,Accept) {
        try {
            if(Accept){
                await acceptReference(referenceId);
            }else{
                await CancelAcceptReference(referenceId);

            }
           
            setShowAccept(false)
            
        } catch (error) {

        }
        getCartableAsync()

    }
    async function undoReferenceAsync(referenceId) {
        try {
            await undoReference(referenceId);
            getCartableAsync()
        } catch (error) {

        }
    }
    async function handleDeleteReference(id = referenceId) {
        try {
            await DeleteReference(id);
            getCartableAsync()
        } catch (error) {

        }
    }

    const selectedStartingProcessCallback = (id: string) => {
        setButtonPrintObj(null)
        setMode("create");
        setSelectedStartingProcessId(id);
        setReferenceId(undefined);
        setModalFormLabel(null)
        getStartFormAsync(id);
    };
    
    const processViewCallback = async (id: string) => {
        try {
        setSelectedStartingProcessId(id);
        getFormViewAsync(id);
        if(rowObject &&rowObject?.Archive){
            const archive = await getArchivedJob(rowObject?.JobId)
            setArchivedList(archive.Data)          
        }
          } catch (error) {
            
          }

    };

    const selectedProcessFilterCallback = (id: string) => {
        if (id === "00000000000000000000000000000000") {
            setSelectedProcessFilterId(null);
        } else {
            setSelectedProcessFilterId(id);
        }
    };
    const selectedArchiveCallback = () => {
        setShowArchiveForm(1)
    };

    const selectedRowCallback = (obj, index) => {
      setRowObject(obj);
      setAcceptResult(false)
       referenceIdRef.current = obj?.Id
       setReferenceId(obj?.Id);
    };

    const showReferenceStepperCallback = (referenceId2: string|boolean) => {
        if(referenceId2!==false){
            if(window.location.href.includes("draft")){
                setRowObject({Id:referenceId2 });
            }
            setReferenceId(referenceId2);
            localStorage.setItem("ShowNewReferene", "null"); 
             sessionStorage.setItem("changingforms", "false")
            setShowReference(true);
            setShowDynamicForm(false);
            setShowDynamicFormView(false);
        }
    };
    const print = () => {
        var printdata = document.getElementsByClassName("printForm")[0] ;
        let newwin:any = window.open("");
        newwin.document.write(printdata.outerHTML);
        newwin.print();
        newwin.close();
            
    };

    const clickToolbarCallback = (clickedButtonName: string, id?) => {      
        switch (clickedButtonName.toLowerCase()) {
            case "reference":
                if (referenceId || id) { setMode("edit"); setShowReference(true); } else {
                    //  Toast(trans("Msg_SelectRow"), "warning") 
                    Toast(trans("Msg_SelectRow"), MessageType.warning) 

                    }
                break;
            case "action":
                if (referenceIdRef.current) {
                    setMode("edit")
                    setShowActionForm(true);
                } else {
                    //  Toast(trans("Msg_SelectRow"), "warning")
                    Toast(trans("Msg_SelectRow"), MessageType.warning) 

                     }
                break;
            case "reminder": if (referenceId) { setMode("edit"); setShowReminder(true); } else { 
                // Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

             } break;
            case "archive": if (referenceId) { selectedArchiveCallback() } break;
         
            case "view": if (referenceId) {setMode("view");  processViewCallback(rowObject?.Id); } else { 
                // Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

             } break;
            case "edit": if (referenceId) { setMode("edit");  processViewCallback(rowObject?.Id);} else {
                //  Toast(trans("Msg_SelectRow"), "warning") 
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

                } break;
            case "print": print(); break;
            case "excel": downloadCSV(response.Data ,( typeOfDataGrid === CartableType.Current|| typeOfDataGrid === CartableType.Ongoing) ?7 :6 ,trans("cartable")+" "+trans(CartableType[type])); break;
            case "remove": if (referenceId){
                // Toast(trans("msg_deleteconfirm"), "warning" , "alert" ,()=>{ type === CartableType.Ongoing ? ongoingReferenceAsync(referenceId, false) :   type === CartableType.Followup ?UnderFollowupAsync(referenceId, false)   : handleDeleteReference() }  )}else { Toast(trans("Msg_SelectRow"), "warning") }     break;
                Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete,()=>{    type === CartableType.Followup ?UnderFollowupAsync(referenceId, false)   : handleDeleteReference() }  )}else 
                // { Toast(trans("Msg_SelectRow"), "warning") }   
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

                  break;



                  case "current": if (referenceId){ type === CartableType.Ongoing && ongoingReferenceAsync(referenceId, false) }else 
                    // { Toast(trans("Msg_SelectRow"), "warning") }   
                    Toast(trans("Msg_SelectRow"), MessageType.warning) 
    
                      break;

            case "finish": if (referenceId) { setShowTerminatedForm(true) } else {
                //  Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

                 } break;
            case "refresh": setReload(true); break;
            case "reverse": if (referenceId) { setMode("edit"); setShowReferDescriptionForm(true) } else { 
                // Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

             }; break;
            case "undo": if (referenceId) { setMode("edit"); undoReferenceAsync(referenceId) } else {
                //  Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning) 
                 }; break;
            case "send": if (referenceId) { setMode("create"); setShowJobSendForm(true) } else {
                //  Toast(trans("Msg_SelectRow"), "warning") 
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

                }; break;
            case "report": if (referenceId)setShowActions(true); break;
            case "attach": if (referenceId) {
                setEndpoint(ENDPOINTS.cartable.attachment)
                setMode("edit")
                setShowAttachment(true)
            } else {
                // Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning) 

            } break; 
        }
    };
    useEffect(() => {
        setLoading(false)
        setPageNum(1);
        if(type != typeOfDataGrid){
            setResponse({ Data: [] })
        }
        setTypeOfDataGrid(type)
        let settings = getGridSetting("cartable" + type + `${selectedProcessFilterId}`)
        setFilterAndSort({Filterlist:settings[0],OrderFormat:settings[1] })
        referenceIdRef.current = null
        setReferenceId(null);
        setRowObject(null);
    }, [type ]);

    async function getCartableAsync(pagNum = pageNum ,searchSTR=search ) {
        setLoading(false)
        keys=[];
        cartable=[];
        setResponse({ Data: [] })
        let sizePage = getPageSize("cartable" + type + `${selectedProcessFilterId}`)
        setPageSize(sizePage)
        try {
            if(type==typeOfDataGrid){
                const res = await getCartable(pagNum, sizePage, type, selectedProcessFilterId, layoutContext.currentUserPosition.PositionId, filterAndSort?.OrderFormat?.join(","), searchSTR, filterAndSort?.Filterlist);
                setUpdated(!Updated)
                layoutContext.setNotificount( res.data.Data?.NewRecords )
                setResponse(res.data.Data);
            }
            setMessageType("info")
        } catch (error) {
            setMessageType("error")
        }
        setLoading(true)
    }

    useEffect(() => {
        setResponse({ Data: [] })
        if(reload ){
            getCartableAsync();
            setReload(false)
        }
        
    }, [reload]);


    useEffect(() => {
        setResponse({ Data: [] })
        setRowObject(null);
        referenceIdRef.current = null
        setReferenceId(null);
        if(filterAndSort != null){
            getCartableAsync();  

        }
        let requesterStorage =localStorage.getItem("ShowNewReferene")
        let NewReferene:any  = {}
        if(requesterStorage == null) {
            NewReferene ={};
        } else {
            NewReferene = JSON.parse(requesterStorage)
        }
        if(NewReferene?.referenceId?.length > 0){
            setRowObject(NewReferene)
            setReferenceId(NewReferene.referenceId);
            setMode("view"); 
            processViewCallback(NewReferene.Id); 
        }
    }, [filterAndSort,  selectedProcessFilterId, layoutContext.currentUserPosition ]);

 
    async function handleFinishedReference(type ,text="",sendMsg=false ) {
        try {
            if(type==="Terminated"){
                 await FinishedReference(referenceId,sendMsg ,text);        
            }else if(type==="CancelTerminate"){ 
                 await CancelFinishedReference(referenceId);
            }else{
                 await RejectReference(referenceId ,text,sendMsg);
            }
            setShowTerminatedForm(false)
            setShowActionForm(false)
            referenceIdRef.current = null
            setReferenceId(null);
            getCartableAsync();             
        } catch (error) {
            
        }
        
    }

    let tabContent = [

        { title: "request" ,body: (<>
                {!showstep[1] &&
                   /*  <DynamicComponentHOC
                    modalFormLabelCallBack={(e)=>setModalFormLabel(e)}
                    parentISCartable={true} buttonPrintObjCallBack={setButtonPrintObj} JobNo={rowObject?.JobNo} RequesterPositionId={rowObject?.RequesterPositionId}  SourceData={rowObject?.SourceData} onHide={() => {localStorage.setItem("ShowNewReferene", "null"); setShowDynamicFormView(false); setReload(true);sessionStorage.setItem("changingforms", "false"); setCurentTab("request") ;setLoading(false)  }} componentName={DYNAMICFORMS[dynamicForm?.Name] ?null:dynamicForm?.Name} component={DYNAMICFORMS[dynamicForm?.Name] ?DYNAMICFORMS[dynamicForm?.Name].component:null}
                        reload={setReload} Name={dynamicForm?.Name} modeParams={type === CartableType.Finished ?"view" :  mode} componentParams={dynamicForm?.Parameters} processId={selectedStartingProcessId}
                        referenceId={referenceId} jobId={rowObject?.JobId} handleCancelForm={() => {localStorage.setItem("ShowNewReferene", "null");showDynamicFormViewCallback(false);sessionStorage.setItem("changingforms", "false");}} handleShowReferenceStepper={showReferenceStepperCallback}
                        /> */

                 <ModalStepper
                     parentISCartable={true}
                     buttonPrintObjCallBack={setButtonPrintObj}
                     sourceId={rowObject?.SourceId}
                     RequesterPositionId={rowObject?.RequesterPositionId}
                     SourceData={rowObject?.SourceData}
                     modalFormLabelCallBack={(e)=>setModalFormLabel(e)}
                     closeForm={() => {localStorage.setItem("ShowNewReferene", "null"); setShowDynamicFormView(false); setReload(true);sessionStorage.setItem("changingforms", "false"); setCurentTab("request") ;setLoading(false)  }}
                     JobNo={rowObject?.JobNo}
                     disable={((rowObject?.AssignType == AssignTypes.SELF_SERVICE&&(!rowObject?.IsGroupTask)&&rowObject?.AcceptTime==null) && showAccept)}
                     inDynamicForms={true}
                     jobId={rowObject?.JobId}
                     onHide={() => {setShowDynamicFormView(false) }}
                     Id={rowObject?.Id}
                     parentMode={mode}
                     taskTitle={rowObject?.TaskTitle}
                     formList={dynamicForm}
                     styleCondition={currentModalWidth}
                    handleCallAttachment={(e)=>{
                    setCreatedRefrenceIdForm(e)
                setEndpoint(ENDPOINTS.cartable.attachment)
                setMode("edit")
                setShowAttachment(true)
                        }}
                     
                     /> 
                        
                }
                { type ==CartableType.Finished&& <JobStatus jobId={rowObject?.JobId}/>}
                     {(archivedList&&archivedList.length >0 )&& 
                                 <div className="card legendCard mt-2">
                                    <div className="legend">{trans("ArchivedIn")}</div>
                                    <div className="card-body ">
                                    <div style={{display:"flex" , flexDirection:"column"  }} className="">
                                     {archivedList.map(item=>(
                                       <div>
                                         {item}
                                       </div>
                                     ))}
                                    </div>
                                     </div >
                                 </div>
                                 
                                 }

        </>), },
       type !=CartableType.Draft&&  { title: "referenceandactionshistory" ,body: ( <ReferencesActions rowObject={rowObject} inTab={curentTab}  cartableType={type} referenceId={referenceId}/>   ), },
       type !=CartableType.Draft&&{ title: "referencestree" ,body: ( <ReferenceTree intab={curentTab=="referencestree"} referenceId={referenceId}/>   ), },

    ];

    useEffect(()=>{
        setCurentTabWithAttachment("request")
    },[DYNAMICFORMS[dynamicForm?.Name],showAttachmentByDynamicForm])




let tabContentWithAttachment = [

        { title: "request" ,body: (<>
              <DynamicComponentHOC 
setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 
                          callAttachmentMoveTemp={(e)=>{setOriginalOwnerId(e) }}
                        modalFormLabelCallBack={(e)=>setModalFormLabel(e)} parentISCartable={true} buttonPrintObjCallBack={setButtonPrintObj} JobNo={rowObject?.JobNo} RequesterPositionId={rowObject?.RequesterPositionId} SourceData={rowObject?.SourceData} 
                        onHide={(usenavigate=false) => {sessionStorage.setItem("changingforms", "false")  ;setLoading(false);setShowDynamicForm(false); if(usenavigate){ navigate("/cartable/draft")}; setReload(true);setCurentTabWithAttachment('request')  }}
                         componentName={DYNAMICFORMS?.[dynamicForm?.Name] ?null:dynamicForm?.Name} component={DYNAMICFORMS?.[dynamicForm?.Name] ?DYNAMICFORMS[dynamicForm?.Name]?.component:null}
                            reload={setReload}  Name={dynamicForm?.Name} TaskId={dynamicForm?.TaskId	} componentParams={dynamicForm?.Parameters} processId={selectedStartingProcessId}
                            referenceId={referenceId}  handleCancelForm={() =>{sessionStorage.setItem("changingforms", "false");setShowDynamicForm(false); }} handleShowReferenceStepper={showReferenceStepperCallback} />
            </>), },

...(
//تعیین شده بود که تب پیوست نمایش داده باشه یا اینکه کلا داینامیک فرم showAttachmentByDynamicForm شرط نمایش: اگر داینامیک فرم بود و داخل داینامیک فرم با استیت
(!DYNAMICFORMS[dynamicForm?.Name] && showAttachmentByDynamicForm) || DYNAMICFORMS?.[dynamicForm?.Name] ? [
     { title: "attachment" ,body: (<>
  
                <Attachment
            curentTabWithAttachment={curentTabWithAttachment}
            temporaryOwnerIdCallBack={(e)=>setTemporaryOwnerId(e)}

                        haveVersion={true} showInGrid={true} onHide={() => { setCreatedRefrenceIdForm(null);setCurentTabWithAttachment('request');setShowAttachment(false); setReload(true) }} mood={mode} endpoint={ENDPOINTS.cartable.reference.attachments} getListEndpoint={endpoint === ENDPOINTS.cartable.attachment ? endpoint : null}getListOwnerId={referenceId}  ownerId={mode=="create"?null:referenceId} />

            </>
            ), }
] : [])


      ,

    ];


    if (response &&
        response.Data && response.Data[0]) {
        keys = Object.keys(response.Data[0]);
    
        cartable = response.Data;
        Total_records = response.TotalRecords;
    } else if (response && response.Data?.length === 0) {
        keys = [];
        cartable = [];
    }
    pages = Total_records > pageSize ? Math.ceil(Total_records / pageSize) : 1;
    const getModalWidth = (modalWidth) => {
        setCurrentModalWidth(modalWidth)
    }


    useEffect(()=>{
        if(OriginalOwnerId && temporaryOwnerId){
            
            //کردن MoveTemp  رو از ریسپانس ذخیره فرم میگیریم و حالا هم اونرآیدی اصلی رو داریم و هم موقت پس درخواست میزنیم برای MoveTempOwnerIdبعد از اینکه فرم ذخیره شد 
                     const MoveTempAsyn=async()=>{
                        try{
   const res = await MoveTemp({tempOwnerId:temporaryOwnerId,ownerId:OriginalOwnerId} ,ENDPOINTS.cartable.reference.attachments  ,null);
                     }catch(error){}
                        }
                  
    
                MoveTempAsyn()
        }
    },[OriginalOwnerId])
   

    return (
        <>
         {showAttachment &&
                    <ModalForm modalHeight={22}  mode={"create"} title={("Attachment")} onHide={() => { setCreatedRefrenceIdForm(null);setShowAttachment(false) }} show={showAttachment}>
                        <Attachment          
                         temporaryOwnerIdCallBack={(e)=>setTemporaryOwnerId(e)}
                        haveVersion={true} showInGrid={true} onHide={() => { setCreatedRefrenceIdForm(null);setShowAttachment(false); setReload(true) }} mood={mode} endpoint={ENDPOINTS.cartable.reference.attachments} getListEndpoint={endpoint === ENDPOINTS.cartable.attachment ? endpoint : null}getListOwnerId={referenceId}  ownerId={mode=="create"?null:referenceId} />
                    </ModalForm>
                }

            <Toolbar
                handleSearch={Searchhandleer}
                handleClickToolbar={clickToolbarCallback}
                handleSelectedStartingProcessToolbar={selectedStartingProcessCallback}
                handleSelectedProcessFilterToolbar={selectedProcessFilterCallback}
                create={type === CartableType.Current|| type === CartableType.Ongoing || type === CartableType.Draft }
                edit={type === CartableType.Draft}
                remove={type === CartableType.Draft || type === CartableType.Followup  }
                current={type === CartableType.Ongoing }
                id={referenceId}
                reference={type === CartableType.Current || type === CartableType.Ongoing || type === CartableType.Draft}
                action={type === CartableType.Current||type === CartableType.Ongoing  }
                report={type === CartableType.Current||type === CartableType.Ongoing  || type === CartableType.Finished}
                reminder={true}
                archive={ type === CartableType.Finished}
                personalArchive={type === CartableType.Current||type === CartableType.Ongoing  || type === CartableType.Finished}
                reverse={type === CartableType.Current||type === CartableType.Ongoing }
                undo={type === CartableType.Referred}
                print={false}
                excel={true}
                Updated={Updated}
                view={type !== CartableType.Current && type !== CartableType.Ongoing }// به درخواست خانوم مهندس برداشته شد 
                RefreshWithNotif={true}
                refresh={true}
                attach={true}
                attachHover={"request"}
                help={true}
                finish={type === CartableType.Current||type === CartableType.Ongoing }
                search={true} />
            <div style={{overflowY: "auto",
             height: "74vh",
            scrollbarWidth: "thin",}} className="col-lg-12 mt-0">
                <div className="list-card card">
                    <div className="list-card__body">
                        {loading ?
                            (cartable.length > 0 && keys ?
                                <DataGrid
                                    handlefiltering={(str:any) => {  str.Filterlist != undefined  ? setFilterAndSort(str) : setFilterAndSort({...filterAndSort, Filterlist:str})}}
                                    orderFormat={(order)=>{setFilterAndSort({...filterAndSort, OrderFormat:order})  }}
                                    orderFormatList={filterAndSort.OrderFormat}
                                    filterStr={filterAndSort.Filterlist}
                                    DoubleClick={(obj) => { referenceIdRef.current = obj.Id; setReferenceId(obj.Id); if (type === CartableType.Current || type === CartableType.Ongoing ){ clickToolbarCallback("action", obj.Id)}else{clickToolbarCallback("view", obj.Id)} }}
                                    View={true}
                                    startIndex={( typeOfDataGrid === CartableType.Current|| typeOfDataGrid === CartableType.Ongoing) ?14 :
                                        typeOfDataGrid === CartableType.Draft?11:
                                        13}
                                    customFuction={customFuction}
                                    handleAttachment={handleAttachmentRow}  
                                    handleAttachmentText={trans("attachment")+" "+trans("reference")}  
                                    selectItem={(e) => {   }}
                                    parentName={"cartable" + type + `${selectedProcessFilterId}`}
                                    theadData={keys}
                                    tbodyData={cartable}
                                    minCellWidth={80}
                                    selectedRowObjectCallback={selectedRowCallback}
                                    rowSelected={rowObject}
                                    totalRecords={Total_records}
                                    pageNum={pageNum}
                                    ViewParametr={"EyeIcon"}
                                    pageSize={pageSize}
                                    handleDelete={type === CartableType.Draft ? handleDeleteReference : null}
                                    HandleNextPage={HandleNextPage}
                                    HandlePrevPage={HandlePrevPage}
                                    handlechangePageSize={handlechangePageSize}
                                    first={() => { getCartableAsync(pages); setPageNum(pages) }}
                                    end={() => { getCartableAsync(1); setPageNum(1) }}
                                    handleGoPage={handleGoPage}
                                />
                                : <Message message={"NoDataForPreview"} type={messageType} />)
                            : <Loading />
                        }
                    </div>
                </div>  
                {ShowReferDescriptionForm &&
                    <ModalForm mode={mode} title={"reverse"} onHide={() => setShowReferDescriptionForm(false)} show={ShowReferDescriptionForm}>
                        <form onSubmit={ReferreverseAsync}>
                            <div className="row mb-1">
                                <div className="col-12">
                                    <Textbox
                                        minHeight={3}
                                        required
                                        textboxType="textarea"
                                        textboxName="ReverseDescription"
                                        labelText="reverseDescription"
                                        mode={"create"}
                                    />
                                </div>
                                <div className="col-4 my-1 my-lg-0 col-lg-4 pt-4">
                                <CheckableButton
                                       defaultValue={false}
                                       labelText={"sendMessageToPerformer"}
                                       inputName={"sendMessageToPerformer"}
                                       type="checkbox"
                                       mode={"edit"}
                                    />    
                            </div>
                            </div>
                            <div className="col-lg-12 mt-1 btns_form">
                                <Button value="Send" btnType="submit" />
                                <Button
                                    btnType="cancel"
                                    value="Cancel"
                                    onClick={() => {
                                        //  Toast(trans("modalclosemessage"), "warning", "alert", () => setShowReferDescriptionForm(false)) 
                                        Toast(trans("modalclosemessage"),MessageType.confirm, () => setShowReferDescriptionForm(false)) 

                                        }}
                                />
                            </div>
                        </form>
                    </ModalForm>
                }
                 {showActions &&
                    <ModalForm mode={"create"} title="reports" onHide={() => setShowActions(false)} show={showActions}>
                        <Actions
                            rowObject={rowObject} 
                            handleShowReferenceStepper={showReferenceStepperCallback}
                            showForm={true}
                            Reload={()=>setReload(true)}
                            onHide={() => setShowActions(false)}
                            mode={"create"}
                            referenceId={referenceId}
                        />
                    </ModalForm>
                }
                {showActionForm &&
                    <ModalForm buttonPrintObj={buttonPrintObj}  mode={"create"} modalProfileKey={"ActionsList"}  title={ `${trans("Actions")} [ ${trans("Process")} : ${rowObject?.IconHover} ]`}  onHide={() => { setShowActionForm(false); setReload(true) }} show={showActionForm} getModalWidth={getModalWidth}>
                        <ActionList  acceptResultCallback={(e)=>setAcceptResult(e)} buttonPrintObjCallBack={(e)=>{
                         ;setButtonPrintObj(e)}} cartableType={type} haveReverse={rowObject?.Reversed}  handleFinishedReference={handleFinishedReference} rowObject={rowObject} onHide={() => { setShowActionForm(false); setReload(true) }} referenceId={referenceId} jobId={rowObject?.JobId} handleShowReferenceStepper={showReferenceStepperCallback} styleCondition={currentModalWidth} />
                    </ModalForm>
                }
                {showTerminatedForm &&
                    <ModalForm mode={"create"} title={("Terminate")} onHide={() => { setShowTerminatedForm(false) }} show={showTerminatedForm} getModalWidth={getModalWidth}>
                        <TerminatedForm rowObject={rowObject} submit={handleFinishedReference}   onHide={() => setShowTerminatedForm(false)} />
                    </ModalForm>
                }   

                {ShowReferenceAndActions &&
                    <ModalForm mode={"create"} title={"referenceandactionshistory"} onHide={() => { setShowReferenceAndActions(false) }} show={ShowReferenceAndActions}>
                        <ReferencesActions
                            cartableType={type}
                            rowObject={rowObject}
                            referenceId={referenceId}
                        />
                    </ModalForm>
                }
                {ShowReferenceTree &&
                    <ModalForm mode={"create"} title={"referencestree"} onHide={() => { setShowReferenceTree(false) }} show={ShowReferenceTree}>
                       <ReferenceTree intab={true} referenceId={referenceId}/>  
                    </ModalForm>
                }

                {showReminder &&
                    <ModalForm mode={"create"} title={("Reminder")} onHide={() => setShowReminder(false)} show={showReminder}>
                        <GroupPerson onHide={() => setShowReminder(false)} label={trans("person")} hasBorder={false} TextBoxName={"CartableReminder"} value={""} SourceId={referenceId} />
                    </ModalForm>
                }     
                {showReference && 
                    <ModalForm modalHeight={74} mode={"create"} title={"ReferenceStepper"} onHide={() => { setShowReference(false) }} show={showReference} getModalWidth={getModalWidth}>
                        <ReferenceStepper acceptResult={acceptResult}  rowObject={rowObject} hideReferenceAndFinish={()=>{setShowReference(false) ;setShowTerminatedForm(true) }}  reload={setReload} onHide={() => { setShowReference(false); setReload(true) }} referenceId={referenceId} styleCondition={currentModalWidth} />
                    </ModalForm>
                }
                {showJobSendForm &&
                    <ModalForm mode={mode} title={"JobSendForm"} onHide={() => setShowJobSendForm(false)} show={showJobSendForm}>
                        <JobSendForm step={1}  mode={mode} onHide={() => setShowJobSendForm(false)} />
                    </ModalForm>
                }
                {showArchiveForm>0 &&
                    <ModalForm mode={mode} title={("ArchiveForm")} onHide={() => setShowArchiveForm(0)} show={showArchiveForm>0}>
                        <ArchiveForm jobId={rowObject?.JobId} Id={rowObject?.Id}  type={showArchiveForm} onHide={() => setShowArchiveForm(0)} />
                    </ModalForm>
                }

                {showDynamicForm &&
                    <ModalForm modalProfileKey={dynamicForm?.Name} buttonPrintObj={buttonPrintObj}  mode={mode} title={
                        !DYNAMICFORMS[dynamicForm?.Name] ?modalFormLabel:dynamicForm?.Name=="LetterForm"?trans(dynamicForm?.Name)+" "+trans(JSON.parse(dynamicForm?.Parameters)?.type):(dynamicForm?.Name)} onHide={() => { setShowDynamicForm(false);setCurentTabWithAttachment('request');setReload(true); }} show={showDynamicForm}>
                 <>
                  {/* <div className="d-none">

 <DynamicComponentHOC 
setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 
                          callAttachmentMoveTemp={(e)=>{setOriginalOwnerId(e) }}
                        modalFormLabelCallBack={(e)=>setModalFormLabel(e)} parentISCartable={true} buttonPrintObjCallBack={setButtonPrintObj} JobNo={rowObject?.JobNo} RequesterPositionId={rowObject?.RequesterPositionId} SourceData={rowObject?.SourceData} 
                        onHide={(usenavigate=false) => {sessionStorage.setItem("changingforms", "false")  ;setLoading(false);setShowDynamicForm(false); if(usenavigate){ navigate("/cartable/draft")}; setReload(true);setCurentTabWithAttachment('request')  }}
                         componentName={DYNAMICFORMS[dynamicForm?.Name] ?null:dynamicForm?.Name} component={DYNAMICFORMS[dynamicForm?.Name] ?DYNAMICFORMS[dynamicForm?.Name].component:null}
                            reload={setReload}  Name={dynamicForm?.Name} TaskId={dynamicForm?.TaskId	} componentParams={dynamicForm?.Parameters} processId={selectedStartingProcessId}
                            referenceId={referenceId}  handleCancelForm={() =>{sessionStorage.setItem("changingforms", "false");setShowDynamicForm(false); }} handleShowReferenceStepper={showReferenceStepperCallback} />
       

                    </div>   */}


{
    (!DYNAMICFORMS[dynamicForm?.Name] && showAttachmentByDynamicForm) || DYNAMICFORMS[dynamicForm?.Name]?
<TabBar  tabChange={tabChangeHandleWithAttachment} content={tabContentWithAttachment} curentTab={curentTabWithAttachment} defaultTab={"request"} />
    
    :
    <DynamicComponentHOC 
setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 
                          callAttachmentMoveTemp={(e)=>setOriginalOwnerId(e) }
                        modalFormLabelCallBack={(e)=>setModalFormLabel(e)} parentISCartable={true} buttonPrintObjCallBack={setButtonPrintObj} JobNo={rowObject?.JobNo} RequesterPositionId={rowObject?.RequesterPositionId} SourceData={rowObject?.SourceData} 
                        onHide={(usenavigate=false) => {sessionStorage.setItem("changingforms", "false")  ;setLoading(false);setShowDynamicForm(false); if(usenavigate){ navigate("/cartable/draft")}; setReload(true);setCurentTabWithAttachment('request')  }}
                         componentName={DYNAMICFORMS[dynamicForm?.Name] ?null:dynamicForm?.Name} component={DYNAMICFORMS[dynamicForm?.Name] ?DYNAMICFORMS[dynamicForm?.Name].component:null}
                            reload={setReload}  Name={dynamicForm?.Name} TaskId={dynamicForm?.TaskId	} componentParams={dynamicForm?.Parameters} processId={selectedStartingProcessId}
                            referenceId={referenceId}  handleCancelForm={() =>{sessionStorage.setItem("changingforms", "false");setShowDynamicForm(false); }} handleShowReferenceStepper={showReferenceStepperCallback} />
       

       
}

</>
                    </ModalForm>
                }
                {showDynamicFormView &&
                    <ModalForm modalProfileKey={dynamicForm?.[0]?.Name} buttonPrintObj={buttonPrintObj} getModalWidth={setCurrentModalWidth}  mode={mode} 
                    title={ShowDynamicFormViewLoading ? !DYNAMICFORMS[dynamicForm?.[0]?.Name] ?modalFormLabel:
                        dynamicForm?.[0]?.Name=="LetterForm"?trans(dynamicForm?.[0]?.Name)+" "+trans(JSON.parse(dynamicForm?.[0]?.Parameters)?.type):
                        (dynamicForm?.[0]?.Name) :"cartableView"}
                    onHide={() => { setShowDynamicFormView(false);setReload(true);setCurentTab("request") }} show={showDynamicFormView}>                       
                        {ShowDynamicFormViewLoading ? 
                            <>
                       {((rowObject?.AssignType == AssignTypes.SELF_SERVICE &&(!rowObject?.IsGroupTask) )&&(rowObject?.referenceId!=undefined ?rowObject?.referenceId==referenceId  :  rowObject?.Id==referenceId) && showAccept && (type ==CartableType.Current ||type === CartableType.Ongoing))&&
                        <AcceptSelfService  isAccepted={!(rowObject?.AcceptTime==null)}  handleAcceptReferenceAsync={(Accept)=>{acceptReferenceAsync(rowObject?.Id ,Accept)}} onHide={(e)=>{e.stopPropagation();  setShowAccept(false)}}/>
                            
                             }
                                                     {showNotes && <Notes refrenceId={referenceId}/>}

                                <TabBar  tabChange={tabChangeHandle} content={tabContent} curentTab={curentTab} defaultTab={"request"} />
                             </>
                          : <Loading/>
                        }
                    </ModalForm>  
                }
            </div>
        </>
    )
}

